import Manage from '@/views/pages/measurables/manage.vue'
import TrackingCode from '@/views/pages/measurables/tracking_code.vue'

export default [
  {
    path: '/measurables-manage',
    name: 'measurables-manage',
    component: Manage
  },
  {
    path: '/measurables-tracking-code',
    name: 'measurables-tracking-code',
    component: TrackingCode
  },
]
